//import { combineReducers } from 'redux';
import { combineReducers } from '@reduxjs/toolkit'
import UserReducer from '../slices/UserSlice';

export default combineReducers({
    user: UserReducer,
})
